import React from 'react'

import PicInput from 'components/Utils/PicInput'
import { Input, Text, Button } from 'components/base'

import ChangeDomain from './ChangeDomain'

function validateName(name: string) {
  if (!name) {
    return 'Name can not be empty'
  }
  return null
}

type SettingsOrganizationInformationsLayoutProps = {
  organizationName: string
  organizationDomain: string
  organizationPhotoURL: string | null
  organizationPhotoState: any
  updateOrganization: (params: any) => void
  updateOrganizationDomain: (domain: string) => void
  updateOrganizationPhoto: (params: any) => void
  useDomainAvailability: (
    organizationDomain: string
  ) => {
    error: string | null
    checkDomainAvailability: (domain: string) => void
  }
}

function SettingsOrganizationInformationsLayout({
  organizationName,
  organizationDomain,
  organizationPhotoURL,
  organizationPhotoState,
  updateOrganization,
  updateOrganizationPhoto,
  updateOrganizationDomain,
  useDomainAvailability,
}: SettingsOrganizationInformationsLayoutProps) {
  const [name, setName] = React.useState<string>(organizationName)
  const [error, setError] = React.useState<string | null>(null)
  const [showChangeDomain, setShowChangeDomain] = React.useState<boolean>(false)

  const onChangeName = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const name = event.target.value
      setName(name)
      setError(validateName(name))
    },
    []
  )

  const setPhotoFile = (photoFile: any) => {
    updateOrganizationPhoto({ photoFile })
  }

  const onSave = (e: React.ChangeEvent<HTMLDivElement>) => {
    e.preventDefault()
    updateOrganization({ name })
  }

  const onReset = () => {
    setName(organizationName)
    setError('')
  }

  return (
    <React.Fragment>
      <Text.Name className="margin-bottom-normal margin-top-large shade-05">
        Photo
      </Text.Name>
      <div className="margin-bottom-larger">
        <PicInput
          help="Image should be at least 300*300px"
          src={organizationPhotoURL}
          onChange={setPhotoFile}
          updateState={organizationPhotoState}
        />
      </div>
      <div className="flexbox">
        <div className="margin-right-medium width-full">
          <Text.Name className="margin-bottom-normal shade-05">
            Team name
          </Text.Name>
          <Input error={error} value={name} onChange={onChangeName} />
          {name !== organizationName && (
            <div className="flexbox flexbox-align-center">
              <Button.Secondary
                className="margin-right-normal"
                onClick={onReset}
              >
                Reset
              </Button.Secondary>
              <Button.Primary onClick={onSave}>Save</Button.Primary>
            </div>
          )}
        </div>
        <div className="width-full">
          <div className="flexbox flexbox-space-between">
            <Text.Name className="margin-bottom-normal shade-05">
              Team domain
            </Text.Name>
            <Text.Action onClick={() => setShowChangeDomain(true)}>
              Change
            </Text.Action>
          </div>
          <Input value={organizationDomain} rightText={'.slite.com'} disabled />
        </div>
      </div>
      <ChangeDomain
        organizationDomain={organizationDomain}
        isOpen={showChangeDomain}
        useDomainAvailability={useDomainAvailability}
        onClose={() => setShowChangeDomain(false)}
        updateOrganizationDomain={updateOrganizationDomain}
      />
    </React.Fragment>
  )
}

export default SettingsOrganizationInformationsLayout
